import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import PageTitle from '../../../components/PageTitle/PageTitle';
import CardGrid from '../../../components/Layout2/CardGrid/CardGrid';
import { ASSETS_BASE_URL, DOCUMENT_EXTERNAL_ENABLED, DOCUMENT_EXTERNAL_URL } from '../../../config';
import GlobalSearch from '../../../components/GlobalSearch/GlobalSearch';
import { useTranslation } from 'react-i18next';
import { useSite } from '../../../context/siteContext';
import { buildExternalLoginUrl } from '../../../utilities/externalDocs';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../constants';

const Home = () => {
    const { t } = useTranslation();
    const { selectedSiteData } = useSite();
    const navigate = useNavigate();

    const handleDocumentationNavigate = () => {
        if (!DOCUMENT_EXTERNAL_ENABLED || !DOCUMENT_EXTERNAL_URL) {
            navigate(ROUTES.DOCUMENT);
            return;
        }
        const username = selectedSiteData?.amf_method_username_ln;
        const password = selectedSiteData?.amf_method_password_ln;
        const loginUrl = buildExternalLoginUrl({
            templateUrl: DOCUMENT_EXTERNAL_URL,
            username,
            password,
        });
        if (!loginUrl) {
            navigate(ROUTES.DOCUMENT);
            return;
        }
        window.open(loginUrl, "_blank", "noopener,noreferrer");
    };

    const homeData = useMemo(() => ([
        { title: t('UI_TEXT.PARTS'), img: `${ASSETS_BASE_URL}/ImageBoxes/parts.jpg`, href: '/parts' },
        { title: t('LABELS.DOCUMENTATION'), img: `${ASSETS_BASE_URL}/ImageBoxes/documentation.jpg`, href: ROUTES.DOCUMENT, onClick: handleDocumentationNavigate },
        { title: t('LABELS.TRAINING'), img: `${ASSETS_BASE_URL}/ImageBoxes/training.jpg`, href: '/training' },
        { title: t('LABELS.SERVICE'), img: `${ASSETS_BASE_URL}/ImageBoxes/service.jpg`, href: '/service' },
    ]), [navigate, selectedSiteData, t]);

    return (
        <>
            {/* <div className="home-slider" style={{ backgroundImage: `url('${ASSETS_BASE_URL}/home_bg3.jpg')` }}>
                <GlobalSearch width="70%" />
            </div> */}
            <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <PageTitle title={t('LABELS.HOME')} />
                <CardGrid data={homeData} />
            </Box>
        </>
    );
};

export default Home;
